<template>
  <LayoutAdmin :active-periode="activePeriodic">
    <section class="w-full px-8 mt-6">
      <div class="flex items-center justify-between w-full">
        <div class="flex items-center">
          <h1 class="text-lg md:text-2xl">Create Task Management</h1>
          <ChoiseCompany @selected:company="company = $event" :options="companies" :dataCompany="company" />
        </div>
        <Button class="px-6 py-2 mx-2 text-white rounded bg-primary h-max" @click="modal.show = true">Add Task</Button>
      </div>
    </section>

    <section class="flex flex-wrap items-center w-10/12 p-2 m-8">
      <div class="flex flex-col">
        <Button
          class="px-6 py-2 text-sm text-gray-400 duration-300 bg-white rounded-full hover:bg-gray-50 hover:text-blue-800"
          :class="filter.dateRange.length ? 'text-primary bg-gray-50' : null" @click="openCreatedDate">Created Date
          <font-awesome-icon icon="fa-xmark" class="ml-3 text-primary" v-if="filter.dateRange.length"
            @click.stop="removeSelectedFilter" />
        </Button>
        <DateRange ref="dateRange" input-class-name="dp-custom-input" v-model="filter.dateRange" :auto-position="false"
          position="left" :enable-time-picker="false" range @update:model-value="selectedDateRange" />
      </div>

      <Dropdown title="Departement" :showDropdown="activeDropdown === 'departement'" :options="departements"
        property="dep_name" :selectedOption="filter.departement" @selected="selectedFilteDepartement($event)"
        @clearSelected="removeFilterDepartement($event)" @update:activeDropdown="changeDropdownActive('departement')" />

      <Dropdown title="Employee" :showDropdown="activeDropdown === 'employee'" :options="employees"
        property="emp_fullname" :selectedOption="filter.employee" @selected="selectedFilterEmployee($event)"
        @clearSelected="removeFilterEmployee($event)" @update:activeDropdown="changeDropdownActive('employee')" />

      <Dropdown title="Status" :showDropdown="activeDropdown === 'status'" :options="listStatus" property="label"
        :selectedOption="filter.status" @selected="selectedFilterStatus($event)"
        @clearSelected="removeFilterStatus($event)" @update:activeDropdown="changeDropdownActive('status')" />
    </section>

    <section class="relative w-full p-4 mb-4">
      <Loading v-if="isLoading" />
      <TabelTaskManagemnent :tasks="filterTasks" :meta="meta" :limit="limit" @edit="showEditModal" @delete="deleteTask"
        @on-page-changed="onPageChanged" />
      <NoDataShowing v-if="tasks.length === 0" />
    </section>
  </LayoutAdmin>
  <ModalCreate v-if="modal.show" :title="modal.title" :companies="companies" @close="closeModal" :id="formTask.id"
    :taskName="formTask.taskName" :company="formTask.company" :start-date="formTask.startDate"
    :end-date="formTask.endDate" :users="formTask.users" :estimate="formTask.estimate" :description="formTask.description"
    :employees="projectUsers" :progress="formTask.progress" :status="formTask.status"
    @update:taskName="(value) => (formTask.taskName = value)" @update:startDate="(value) => (formTask.startDate = moment(value).format('YYYY-MM-DD'))
      " @update:endDate="(value) => (formTask.endDate = moment(value).format('YYYY-MM-DD'))
    " @update:users="(value) => (formTask.users = value)" @update:estimate="(value) => (formTask.estimate = value)"
    @update:description="(value) => (formTask.description = value)"
    @update:progress="(value) => (formTask.progress = value)" @update:status="(value) => (formTask.status = value)"
    @on-selected-company="(value) => (formTask.company = value)" @on-submit="onSubmitTask" />
</template>

<script>
import LayoutAdmin from "../components/Layout/Admin.vue";
import Dropdown from "@/components/Dropdown.vue";
import ChoiseCompany from "@/components/ChoiseCompany.vue";
import TabelTaskManagemnent from "@/components/Task/TabelTask.vue";
import Button from "@/components/Button.vue";
import ModalCreate from "@/components/Task/ModalCreate.vue";
import NoDataShowing from "@/components/NoDataShowing.vue";
import Loading from "@/components/Loading.vue";
import { GetAllCompanyEmployeeOptionsAPI } from "@/actions/company";
import { getTask, createTask, deleteTask, updateTask } from "@/actions/task";
import { GetAllEmployementAPI } from "@/actions/employment";
import { useToast } from "vue-toastification";
import { GetDepartementAPI } from "@/actions/departement";
import { GetPeriodicActiveAPI } from "@/actions/periodic";
import moment from "moment";
import Swal from "sweetalert2";
import DateRange from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

export default {
  name: "TaskMagement",
  components: {
    LayoutAdmin,
    ChoiseCompany,
    TabelTaskManagemnent,
    Button,
    ModalCreate,
    NoDataShowing,
    Loading,
    DateRange,
    Dropdown,
  },
  data() {
    return {
      activePeriodic: "-",
      company: {},
      companies: [],
      tasks: [],
      formTask: {
        id: null,
        taskName: "",
        company: null,
        startDate: "",
        endDate: "",
        users: [],
        estimate: 0,
        description: "",
        progress: 0,
        status: "",
      },
      projectUsers: [],
      employees: [],
      modal: {
        show: false,
        title: "Create",
      },
      page: 1,
      limit: 10,
      isLoading: false,
      meta: {},
      filter: {
        dateRange: [],
        departement: "",
        employee: "",
        status: "",
      },
      departements: [],
      showFilterRange: false,
      activeDropdown: "",
      listStatus: [
        { value: "not_started", label: "Not Started" },
        { value: "ongoing", label: "Ongoing" },
        { value: "passed", label: "Passed" },
        { value: "stoped", label: "Stoped" },
      ],
    };
  },
  setup() {
    const toast = useToast();
    return { toast, moment };
  },
  watch: {
    company: {
      handler() {
        this.page = 1;
        this.getTask();
        this.getDepartement();
        this.getEmployee();
        this.handleGetPeriodicActive();
      },
      deep: true,
    },
    "formTask.company": {
      handler(newValue) {
        if (newValue !== null) {
          this.getProjectUsers();
        }
      },
      deep: true,
    },
  },
  computed: {
    filterTasks() {
      return this.tasks.filter((task) => task.task_workers.length);
    },
  },
  mounted() {
    this.getAllCompany();
  },
  methods: {
    async getAllCompany() {
      const response = await GetAllCompanyEmployeeOptionsAPI();
      this.companies = response?.data;
      this.company = response?.data[0];
    },
    async handleGetPeriodicActive() {
      const querySuperAdmin = `?company_id=${this?.company?._id}`;
      const response = await GetPeriodicActiveAPI(querySuperAdmin);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      console.log(response?.data);
      this.activePeriodic = response?.data?.periodic_month + " (" + response?.data?.periodic_start_date + " to " + response?.data?.periodic_end_date + ")";
    },
    async getDepartement() {
      const querySuperAdmin = `?company=${this.company?._id}`;
      const response = await GetDepartementAPI(querySuperAdmin);
      if (response.status === 401) {
        return this.$router.push("/login");
      }
      this.departements = response.data;
    },
    async getTask() {
      this.isLoading = true;
      const { data, message, success, code, meta } = await getTask({
        companyId: this.company?._id,
        page: this.page,
        limit: this.limit,
        createdDate: this.filter.dateRange,
        departementId: this.filter.departement,
        employeeId: this.filter.employee,
        status: this.filter.status,
      });
      if (success) {
        this.tasks = data;
        this.isLoading = false;
        this.meta = meta;
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else {
          this.toast.error(message);
        }
      }
    },
    async getProjectUsers() {
      const querySuperAdmin = `?company=${this.company._id}`;
      const response = await GetAllEmployementAPI(querySuperAdmin);
      if (response.status === 401) {
        this.$store.commit("changeIsLoggedIn", false);
        return this.$router.push("/login");
      }
      const mapEmpoyees = response?.data?.map((employeee) => {
        return {
          value: employeee?._id,
          label: employeee?.emp_fullname,
        };
      });
      this.projectUsers = mapEmpoyees;
    },
    async getEmployee() {
      const querySuperAdmin = `?company=${this.company?._id}`;
      const response = await GetAllEmployementAPI(querySuperAdmin);
      if (response.status === 401) {
        this.$store.commit("changeIsLoggedIn", false);
        return this.$router.push("/login");
      }
      this.employees = response?.data;
    },
    async onSubmitTask() {
      const getAccountData = localStorage.getItem("accountData");
      const accountData = JSON.parse(getAccountData);
      const payload = {
        company_id: this.formTask.company,
        task_name: this.formTask.taskName,
        task_date_start: this.formTask.startDate,
        task_date_end: this.formTask.endDate,
        estimated_hours: this.formTask.estimate,
        task_workers: this.formTask.users,
        task_desc: this.formTask.description,
        created_by: accountData.company_id,
        progress: this.formTask.progress,
        task_status: this.formTask.status,
      };
      if (this.formTask.id !== null) {
        this.updateTask(payload);
      } else {
        this.createTask(payload);
      }
    },
    async updateTask(payload) {
      const { message, success, code, errors } = await updateTask({
        id: this.formTask.id,
        payload,
      });
      if (success) {
        this.toast.success("Updated task successfully");
        this.modal.show = false;
        this.getTask();
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else if (code == 400) {
          errors.map((error) => {
            const key = Object.keys(error)[0];
            this.toast.error(error[key]);
          });
        } else {
          this.toast.error(message);
        }
      }
    },
    async createTask(payload) {
      const { message, success, code, errors } = await createTask(payload);
      if (success) {
        this.toast.success("Created task successfully");
        this.modal.show = false;
        this.getTask();
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else if (code == 400) {
          errors.map((error) => {
            const key = Object.keys(error)[0];
            this.toast.error(error[key]);
          });
        } else {
          this.toast.error(message);
        }
      }
    },
    deleteTask(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "For delete this data",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { success, code, message } = await deleteTask(id);
          if (success) {
            this.toast.success("Deleted task successfully");
            this.getTask();
          } else {
            if (code === 401) {
              return this.$router.push("/login");
            } else {
              this.toast.error(message);
            }
          }
        }
      });
    },
    showEditModal(data) {
      const users = data.task_workers.map((worker) => {
        return worker._id;
      });
      this.formTask = {
        id: data._id,
        taskName: data.task_name,
        company: data.company_id?._id,
        startDate: data.task_date_start,
        endDate: data.task_date_end,
        users: users,
        estimate: data.estimated_hours,
        description: data.task_desc,
        progress: data.progress,
        status: data.task_status,
      };
      this.modal.show = true;
      this.modal.title = "Edit";
    },
    closeModal() {
      this.modal.show = false;
      this.formTask = {
        id: null,
        taskName: "",
        company: null,
        startDate: "",
        endDate: "",
        users: [],
        estimate: 0,
        description: "",
      };
      this.employees = [];
    },
    openCreatedDate() {
      this.$refs.dateRange.openMenu();
    },
    changeDropdownActive(id) {
      if (this.activeDropdown === id) {
        this.activeDropdown = false;
      } else {
        this.activeDropdown = id;
      }
    },
    onPageChanged(value) {
      this.page = value;
      this.getTask();
    },
    selectedDateRange() {
      this.page = 1;
      this.filter.dateRange = this.filter.dateRange.map((date) => {
        return moment(date).format("YYYY-MM-DDTHH:mm:ssZ");
      });
      this.getTask();
    },
    removeSelectedFilter() {
      this.page = 1;
      this.filter.dateRange = [];
      this.getTask();
    },
    selectedFilteDepartement(value) {
      this.page = 1;
      this.filter.departement = value._id;
      this.getTask();
    },
    removeFilterDepartement() {
      this.page = 1;
      this.filter.departement = "";
      this.getTask();
    },
    selectedFilterEmployee(value) {
      this.page = 1;
      this.filter.employee = value._id;
      this.getTask();
    },
    removeFilterEmployee() {
      this.page = 1;
      this.filter.employee = "";
      this.getTask();
    },
    selectedFilterStatus(status) {
      this.page = 1;
      this.filter.status = status.value;
      this.getTask();
    },
    removeFilterSelected() {
      this.page = 1;
      this.filter.status = "";
      this.getTask();
    },
  },
};
</script>

<style lang="scss">
.dp-custom-input,
.dp__icon {
  display: none;
}

// .dp__input_wrap {
//   display: none;
// }
</style>
